// extracted by mini-css-extract-plugin
export default {"mCard":"ZE-z","image":"_E-z","imageNoBackground":"aF-z","imageHasCategory":"bF-z","fullWidth":"cF-z"};